export default __webpack_public_path__ + "static/media/person_3@2x.ffff40ed.png";